
class FrameModifications extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('[js-product-info]').querySelector('form[action="/cart/add"]');
    this.materialIndex = this.getAttribute('data-material-index') || 0;
    this.selectedMaterial = this.getAttribute('data-selected-material') || null;
    this.options =  this.querySelectorAll('[js-frame-options]');
    this.borderOptions = this.querySelectorAll('[js-border-options]');
    this.borders = this.querySelector('[js-borders]');
    this.selected = this.dataset.selectOptionText;
    this.border = 'With Border';
    this.productRenderer = this.closest('product-rerender');

    this.colorLabel = this.querySelector('[js-color]');
    this.borderLabel = this.querySelector('[js-border]');

    // Run after the browser paints, so the variant picker DOM is in place
    if (this.selectedMaterial != '' && this.productRenderer.getAttribute('observe-form').indexOf('product-form-main') > -1) {
      requestAnimationFrame(() => {
        this.autoSelectFramedMaterial(this.selected);
      });
    }    

    this.handleVariantChange(this.selectedMaterial);
    this.handleOptionChange();
    
    this.form.addEventListener('variant:change', (event) => {
        const variant = event.detail.variant;
        this.selectedMaterial = variant.options[this.materialIndex];
        if (variant){
            this.handleVariantChange(variant.options[this.materialIndex]);
        }
     })
  }

  handleVariantChange(materialOption) {
    if (!materialOption) return;

    const hasMaterials = Array.from(this.options).some(option => {
      const materials = option.getAttribute('data-materials').split(',');
      return materials.includes(materialOption);
    });
    
    if (!hasMaterials) {
      this.classList.add('frames-hidden');
      for (const option of this.options) {
        option.checked = false;
      }

      for (const option of this.borderOptions) {
        option.checked = false;
        this.border = 'With Border';
      }

      let imageUrl = '';
      if (materialOption.toLowerCase().indexOf('canvas') > -1) {
        imageUrl = this.dataset.canvasImage;
      } else if (materialOption.toLowerCase().indexOf('acrylic') > -1) {
        imageUrl = this.dataset.acrylicImage;
      }

      this.updateFrameImage(imageUrl);
      return;
    }

    const firstVisibleOption = Array.from(this.options).find(option => {
      const materials = option.getAttribute('data-materials').split(',');
      return materials.includes(materialOption);
    });

    if (firstVisibleOption) {
      firstVisibleOption.checked = true;
    }
    for (const option of this.options) {
      const materials = option.getAttribute('data-materials').split(',');
      if (materials.includes(materialOption)) {
        option.parentElement.classList.remove('frames-hidden');
        this.classList.remove('frames-hidden');
      } else {
        option.parentElement.classList.add('frames-hidden');
      }
    }

    this.borderOptions[0].checked = true;

    if (materialOption.toLowerCase().indexOf('canvas') > -1) {
      this.borders.classList.add('frames-hidden');
      for (const option of this.borderOptions) {
        option.checked = false;
      }
    } else {
      this.borders.classList.remove('frames-hidden');
    }


    this.getFrameImage(materialOption);
    this.colorLabel.textContent = this.options[0].value;
  }

  handleOptionChange() {
    this.borderOptions.forEach(option => {
      option.addEventListener('change', () => {
        this.borderLabel.textContent = option.value;
        this.border = option.value;
        this.getFrameImage(this.selectedMaterial);
      });
    });

    this.options.forEach(option => {
      option.addEventListener('change', () => {
        this.colorLabel.textContent = option.value;
        this.getFrameImage(this.selectedMaterial);
      });
    });
  }

  updateFrameImage(url) {
    const productRenderer = this.closest('product-rerender');
    const gallery = productRenderer?.querySelector('product-gallery');
    const firstImage = gallery?.querySelector('.product-gallery__media.is-initial');

    if (!firstImage) return;
    
    firstImage.style.borderImageSource = `url(${url})`;
    if (url == '') {
      firstImage.classList.remove('product-gallery__media--frame', 'product-gallery__media--shadow', 'product-gallery__media--border', 'product-gallery__media--alt', 'product-gallery__media--overlay');
    } else {
      firstImage.classList.add('product-gallery__media--frame');
      firstImage.classList.add('product-gallery__media--shadow');

      if (this.selectedMaterial.toLowerCase().indexOf('fine art print (framed)') > -1) {
        
        firstImage.classList.remove('product-gallery__media--alt', 'product-gallery__media--overlay');
        if (this.border == 'With Border') {
          firstImage.classList.add('product-gallery__media--border');
        } else {
          firstImage.classList.remove('product-gallery__media--border');
        }
      } else {
        const overlayElement  = firstImage.querySelector(`[js-media-overlay]`);
        const overlayImage = this.selectedMaterial.toLowerCase().indexOf('canvas') > -1 ? this.dataset.canvasImage : this.dataset.acrylicImage;
        firstImage.classList.add('product-gallery__media--overlay');
        firstImage.classList.remove('product-gallery__media--border', 'product-gallery__media--alt', 'product-gallery__media--frame');

        if (overlayElement) { 
          console.log('setting overlay image to', overlayImage);
          overlayElement.style.backgroundImage = `url(${overlayImage})`;
          overlayElement.classList.remove('frames-hidden');
        }

        if (this.selectedMaterial.toLowerCase().indexOf('canvas (framed)') > -1) {
          firstImage.classList.add('product-gallery__media--frame');
        } else {
          firstImage.classList.remove('product-gallery__media--frame');
        }
      }
    }

    // const frameImage = this.closest('[js-product-info]').querySelector('[js-frame-image]');
    // if (!frameImage) return;

    // frameImage.src = url;
  }

  getFrameImage(materialOption) {
    const selectedMaterialOption = this.querySelector('input[name="properties[Finish]"]:checked');
    if (!selectedMaterialOption) return;

    const borderImage = selectedMaterialOption.getAttribute('data-frame-with-border');
    const noBorderImage = selectedMaterialOption.getAttribute('data-frame-no-border');

    if (materialOption.toLowerCase().indexOf('canvas') > -1) {
      const selectedImage = selectedMaterialOption.getAttribute('data-canvas-frame');

      this.updateFrameImage(selectedImage);
    } else {

      // Helper to update the <img> inside the label next to a given border input
      const setOptionImg = (borderValue, src) => {
        if (!src) return;

        const input = Array.from(this.borderOptions).find(opt => opt.value === borderValue);
        if (!input) return;

        const img = input.nextElementSibling?.querySelector('img');
        if (!img) return;

        img.removeAttribute('srcset');
        img.src = src;
      };

      setOptionImg('No Border', noBorderImage);
      setOptionImg('With Border', borderImage);

      // return whichever is currently selected 
      const selectedBorder = this.querySelector('input[name="properties[Frame Border]"]:checked')?.value;
      this.updateFrameImage(selectedBorder === 'No Border' ? noBorderImage : borderImage);
    }
  }

  autoSelectFramedMaterial(selectedMaterial) {
    const variantPicker = this.closest('[js-product-info]').querySelector('variant-picker');
    if (!variantPicker) return;

    // Find the fieldset that corresponds to "Material"
    const normalizeLegend = (legendEl) => {
      if (!legendEl) return '';
      return legendEl.textContent
        .replace(/\s+/g, ' ')   // collapse whitespace/newlines
        .trim()
        .replace(/:$/, '')      // remove trailing colon if present
        .toLowerCase();
    };

    const fieldsets = Array.from(
      variantPicker.querySelectorAll('fieldset.variant-picker__option')
    );

    const materialFieldset = fieldsets.find(fs => {
      const legend = fs.querySelector('legend');
      return normalizeLegend(legend) === 'material';
    });

    if (!materialFieldset) return;

    // In most selector styles, labels point to inputs via for="inputId"
    const labels = Array.from(materialFieldset.querySelectorAll('label'));
    const targetLabel = labels.find(label =>
      label.textContent.replace(/\s+/g, ' ').trim().includes(selectedMaterial)
    );

    if (!targetLabel) return;

    const inputId = targetLabel.getAttribute('for');
    if (!inputId) return;

    const input = materialFieldset.querySelector(`#${CSS.escape(inputId)}`);
    if (!input) return;

    // Select and trigger VariantPicker's delegated change listener
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

}

customElements.define('frame-modifications', FrameModifications)
